<template>
	<div
		@click="onSetupClick"
		ref="flow_tree_configurations_section"
		:class="{ selected: isSetupDrawerOpen }"
		class="setup-node-container display-flex flex-row flex-centerize mb-6"
	>
		<div class="setup-test-status-container flex-centerize">
			<component v-bind:is="testStatusIcon" />
		</div>

		<div class="icon-container ml-n4 mr-2 flex-centerize">
			<SIcon name="setup" :width="24" />
		</div>
		Setup
	</div>
</template>

<script>
import { mapActionsShorthand } from '@/store/utils/mappers';
import { mapGetters, mapActions } from 'vuex';
import { setFocusedElement } from '@/store/modules/flowTree/actions';
import { DRAWER_MODES } from '@/store/modules/leftSideDrawer/state';
import { isLeftSideDrawerOpen } from '@/store/modules/leftSideDrawer/getters';
import { setLeftSideDrawerState } from '@/store/modules/leftSideDrawer/actions';
import { generalConfiguration, userSpecificConfiguration } from '@/store/modules/selectedWorkflow/modules/configurations/getters';
import { NodeTypes } from '@/components/FlowTree/flow-tree-service.const';

import WorkflowConfigurationService from '@/utils/workflow-configuration-service';

import IconSuccess from '@/components/FlowTreeBlock/assets/icon-vi.svg';
import IconWarning from '@/components/FlowTreeBlock/assets/icon-exclamation-unknown.svg';

export default {
	name: 'FlowTreeConfigurationsSection',
	components: {},
	computed: {
		...mapGetters([generalConfiguration.fullPath, userSpecificConfiguration.fullPath, isLeftSideDrawerOpen.fullPath]),
		testStatusIcon() {
			return !this.hasConfiguration ? null : this.isSetupSuccessful ? IconSuccess : IconWarning;
		},
		hasConfiguration() {
			return !!this.generalConfiguration || !!this.userSpecificConfiguration;
		},
		generalConfiguration() {
			return this[generalConfiguration.fullPath];
		},
		userSpecificConfiguration() {
			return this[userSpecificConfiguration.fullPath];
		},
		isSetupDrawerOpen() {
			return this[isLeftSideDrawerOpen.fullPath];
		},
		isSetupSuccessful() {
			let isTestedSuccesfully = true;
			if (this.generalConfiguration) {
				isTestedSuccesfully = isTestedSuccesfully && this.isConfigurationRespondedSuccessfully(this.generalConfiguration);
			}
			if (this.userSpecificConfiguration) {
				isTestedSuccesfully = isTestedSuccesfully && this.isConfigurationRespondedSuccessfully(this.userSpecificConfiguration);
			}
			return isTestedSuccesfully;
		},
	},
	methods: {
		...mapActions([setLeftSideDrawerState.fullPath]),
		...mapActionsShorthand({ setFocusedElement }),
		isConfigurationRespondedSuccessfully(configuration) {
			return WorkflowConfigurationService.isConfigurationRespondedSuccessfully(configuration);
		},
		onSetupClick() {
			this[setLeftSideDrawerState.fullPath](this.isSetupDrawerOpen ? DRAWER_MODES.closed : DRAWER_MODES.test);
			this.setFocusedElement(NodeTypes.Setup);
		},
	},
};
</script>

<style lang="scss" scoped>
.block-status-mark {
	top: -19px;
	left: -27px;
	position: relative;
	z-index: 999;
	transform: translate(-25%, -30%);
}
.setup-node-container {
	width: 120px;
	height: 40px;
	border-radius: 8px;
	cursor: pointer !important;
	border: 1px solid var(--button-border);
	background: var(--setup-node-container-background);

	&:hover {
		opacity: 0.85;
	}

	font-size: 14px;
	color: var(--setup-black);
	&.selected {
		border-radius: 8px;
		box-shadow: 0px 3px 6px #6eb7ff77;
		border: 1px solid var(--primary-border-color);
		background: var(--selected-tree-block-background);
	}

	.setup-test-status-container {
		min-width: 14px;
		min-height: 14px;
		border-radius: 50%;
		background: #eff2f9;
		border: 1px solid #dae0ec;

		top: -19px;
		left: -27px;
		position: relative;
	}

	.icon-container {
		width: 36px;
		height: 32px;
		border-radius: 8px;
		background: var(--bg-color);
		border: 1px solid var(--border-color);
	}
}
</style>
